import moment from 'moment';
import axios from 'axios';


export const hora1MayorAHora2 = (horaActualServidor, horaFinAtencionAJ) => {
  const [hora1Horas, hora1Minutos] = horaActualServidor.split(':').map(Number);
  const [hora2Horas, hora2Minutos] = horaFinAtencionAJ.split(':').map(Number);
  const minutosTotalesHora1 = hora1Horas * 60 + hora1Minutos;
  const minutosTotalesHora2 = hora2Horas * 60 + hora2Minutos;
  return minutosTotalesHora1 > minutosTotalesHora2;
};

export default {
  install(Vue) {
    const validacion = {
      puedeModificarAmpliar(puedeAmpliar, puedeModificar, puedeAmpliarModificar, raa, mensajeCuandoNotienRAA, modulo) {
        var result = true;
        var mensaje = '';
        if (raa == null) {
          { result = false; mensaje = 'Aún no cuenta con la Resolución Administrativa de Autorización, por tanto no se puede iniciar un trámite de: ' + mensajeCuandoNotienRAA }
        } else {

          if (modulo != "inclusion_exclusion") {
            if (!puedeAmpliarModificar ||
              (!puedeAmpliar && !puedeModificar)) { result = false; mensaje = 'Cantidad Ampliación y Modificación supera a la cantidad permitida' }

            if (!puedeAmpliar) { result = true; mensaje = 'Cantidad de Ampliaciones supera a la cantidad permitida'; };

            if (!puedeModificar) { result = true; mensaje = 'Cantidad de Modificaciones supera a la cantidad permitida' };
          }
        }

        return { resultado: result, mensaje: mensaje }
      },
      esNumero_y_2_Decimal(valor) {
        if (/^\d*(\.\d{2})$/.test(valor)) return true;
        else return false;
      },

      esNumero(valor) {
        if (/^[0-9]+$/.test(valor)) return true;
        else return false;
      },
      valorDecimalCorrecto(valor) {
        if (valor == null) {

        } else if (/^[0-9]+$/.test(valor)) {

        } else if (/^\d*(\.\d{2})$/.test(valor)) {

        }
        else if (/^\d*(\.\d{1})$/.test(valor)) {

        }
        else {
          return false;
        }
        return true;
      },

      esHoraCorrecta(horaEvento) {
        if (horaEvento != null) {
          if (horaEvento.length < 5)
            return false;

          var vHora = horaEvento.split(':');

          if (vHora[0] > 23 || vHora[0] < 0)
            return false;
          if (vHora[1] > 59 || vHora[1] < 0)
            return false;
        }

        return true;
      },
      esFechaFinAmpliacionSorteoCorrecto(vFechaFinSorteo, fechaInicioSorteo, fechaInicioPe, fechaFinPe) {
        var objResult = { status: true, message: '' }
        var m_vFechaFinSorteo = moment(vFechaFinSorteo, ['DD/MM/YYYY']);
        var m_fechaInicioSorteo = moment(fechaInicioSorteo, ['DD/MM/YYYY']);
        var m_fechaInicioPe = moment(fechaInicioPe, ['DD/MM/YYYY']);
        var m_fechaFinPe = moment(fechaFinPe, ['DD/MM/YYYY']);

        if (m_vFechaFinSorteo.isValid()) {
          if (fechaInicioSorteo != null) {
            if (m_vFechaFinSorteo < m_fechaInicioSorteo) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser inferior a la fecha Inicio (${fechaInicioSorteo}) de Lugar de Sorteo`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe != null) {
            if ((m_vFechaFinSorteo > m_fechaFinPe) || (m_vFechaFinSorteo < m_fechaInicioPe)) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe estar fuera de rango de fecha de la Promoción (desde: ${fechaInicioPe} hasta: ${fechaFinPe}).`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe == null) {
            if (m_vFechaFinSorteo > m_fechaFinPe) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser Superior a la fecha (${fechaFinPe}) Fin de la Promoción`
              }
            }
          }
          if (fechaInicioPe == null && fechaFinPe != null) {
            if (m_vFechaFinSorteo < m_fechaInicioPe) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser inferior a la fecha (${fechaInicioPe}) Inico de la Promoción`
              }
            }
          }

        } else {
          objResult = {
            status: false, message: `Formato Incorrecto, el formato de fecha debe ser DD/MM/YYYY`
          }
        }
        return objResult;
      },
      esFechaInicioAmpliacionSorteoCorrecto(vFechaInicioEntrega, fechaFinEntrega, fechaInicioPe, fechaFinPe) {

        var objResult = { status: true, message: '' }
        var m_vFechaInicioEntrega = moment(vFechaInicioEntrega, ['DD/MM/YYYY']);
        var m_fechaFinSorteo = moment(fechaFinEntrega, ['DD/MM/YYYY']);
        var m_fechaInicioPe = moment(fechaInicioPe, ['DD/MM/YYYY']);
        var m_fechaFinPe = moment(fechaFinPe, ['DD/MM/YYYY']);

        if (m_vFechaInicioEntrega.isValid()) {
          if (fechaFinEntrega != null) {
            if (m_vFechaInicioEntrega > m_fechaFinSorteo) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser superior a la fecha Fin (${fechaFinEntrega}) de Lugar de Sorteo`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe != null) {
            if ((m_vFechaInicioEntrega > m_fechaFinPe) || (m_vFechaInicioEntrega < m_fechaInicioPe)) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe estar fuera de rango de fecha de la Promoción (desde: ${fechaInicioPe} hasta: ${fechaFinPe}).`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe == null) {
            if (m_vFechaInicioEntrega > m_fechaFinPe) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser Superior a la fecha (${fechaFinPe}) Fin de la Promoción`
              }
            }
          }
          if (fechaInicioPe == null && fechaFinPe != null) {
            if (m_vFechaInicioEntrega < m_fechaInicioPe) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser inferior a la fecha (${fechaInicioPe}) Inico de la Promoción`
              }
            }
          }

        } else {
          objResult = {
            status: false, message: `Formato Incorrecto, el formato de fecha debe ser DD/MM/YYYY`
          }
        }
        return objResult;
      },
      esFechaFinAmpliacionEntregaCorrecto(vFechaFinEntrega, fechaInicioEntrega, fechaInicioPe, fechaFinPe) {

        var objResult = { status: true, message: '' }
        var m_vFechaFinEntrega = moment(vFechaFinEntrega, ['DD/MM/YYYY']);
        var m_fechaInicioEntrega = moment(fechaInicioEntrega, ['DD/MM/YYYY']);
        var m_fechaInicioPe = moment(fechaInicioPe, ['DD/MM/YYYY']);
        var m_fechaFinPe = moment(fechaFinPe, ['DD/MM/YYYY']);

        if (m_vFechaFinEntrega.isValid()) {
          if (fechaInicioEntrega != null) {
            if (m_vFechaFinEntrega < m_fechaInicioEntrega) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser inferior a la fecha Inicio (${fechaInicioEntrega}) de Lugar de Sorteo`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe != null) {
            if ((m_vFechaFinEntrega > m_fechaFinPe) || (m_vFechaFinEntrega < m_fechaInicioPe)) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe estar fuera de rango de fecha de la Promoción (desde: ${fechaInicioPe} hasta: ${fechaFinPe}).`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe == null) {
            if (m_vFechaFinEntrega > m_fechaFinPe) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser Superior a la fecha (${fechaFinPe}) Fin de la Promoción`
              }
            }
          }
          if (fechaInicioPe == null && fechaFinPe != null) {
            if (m_vFechaFinEntrega < m_fechaInicioPe) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser inferior a la fecha (${fechaInicioPe}) Inico de la Promoción`
              }
            }
          }

        } else {
          objResult = {
            status: false, message: `Formato Incorrecto, el formato de fecha debe ser DD/MM/YYYY`
          }
        }
        return objResult;
      },
      esFechaInicioAmpliacionEntregaCorrecto(vFechaInicioEntrega, fechaFinEntrega, fechaInicioPe, fechaFinPe) {

        var objResult = { status: true, message: '' }
        var m_vFechaInicioEntrega = moment(vFechaInicioEntrega, ['DD/MM/YYYY']);
        var m_fechaFinSorteo = moment(fechaFinEntrega, ['DD/MM/YYYY']);
        var m_fechaInicioPe = moment(fechaInicioPe, ['DD/MM/YYYY']);
        var m_fechaFinPe = moment(fechaFinPe, ['DD/MM/YYYY']);

        if (m_vFechaInicioEntrega.isValid()) {
          if (fechaFinEntrega != null) {
            if (m_vFechaInicioEntrega > m_fechaFinSorteo) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser superior a la fecha Fin (${fechaFinEntrega}) de Lugar de Sorteo`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe != null) {
            if ((m_vFechaInicioEntrega > m_fechaFinPe) || (m_vFechaInicioEntrega < m_fechaInicioPe)) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe estar fuera de rango de fecha de la Promoción (desde: ${fechaInicioPe} hasta: ${fechaFinPe}).`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe == null) {
            if (m_vFechaInicioEntrega > m_fechaFinPe) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser Superior a la fecha (${fechaFinPe}) Fin de la Promoción`
              }
            }
          }
          if (fechaInicioPe == null && fechaFinPe != null) {
            if (m_vFechaInicioEntrega < m_fechaInicioPe) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser inferior a la fecha (${fechaInicioPe}) Inico de la Promoción`
              }
            }
          }

        } else {
          objResult = {
            status: false, message: `Formato Incorrecto, el formato de fecha debe ser DD/MM/YYYY`
          }
        }
        return objResult;
      },
      esFechaInicioEntregaCorrecto(vFechaInicioEntrega, fechaFinEntrega, fechaInicioPe, fechaFinPe) {
        var objResult = { status: true, message: '' }
        var m_vFechaInicioEntrega = moment(vFechaInicioEntrega, ['DD/MM/YYYY']);
        var m_fechaFinSorteo = moment(fechaFinEntrega, ['DD/MM/YYYY']);
        var m_fechaInicioPe = moment(fechaInicioPe, ['DD/MM/YYYY']);
        var m_fechaFinPe = moment(fechaFinPe, ['DD/MM/YYYY']);

        if (m_vFechaInicioEntrega.isValid()) {
          if (fechaFinEntrega != null) {
            if (m_vFechaInicioEntrega > m_fechaFinSorteo) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser superior a la fecha Fin (${fechaFinSorteo}) de Lugar de Sorteo`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe != null) {
            if ((m_vFechaInicioEntrega > m_fechaFinPe) || (m_vFechaInicioEntrega < m_fechaInicioPe)) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe estar fuera de rango de fecha de la Promoción (desde: ${fechaInicioPe} hasta: ${fechaFinPe}).`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe == null) {
            if (m_vFechaInicioEntrega > m_fechaFinPe) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser Superior a la fecha (${fechaFinPe}) Fin de la Promoción`
              }
            }
          }
          if (fechaInicioPe == null && fechaFinPe != null) {
            if (m_vFechaInicioEntrega < m_fechaInicioPe) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser inferior a la fecha (${fechaInicioPe}) Inico de la Promoción`
              }
            }
          }

        } else {
          objResult = {

            status: false, message: `Formato Incorrecto, el formato de fecha debe ser DD/MM/YYYY`
          }
        }
        return objResult;
      },
      esFechaFinEntregaCorrecto(vFechaFinEntrega, fechaInicioEntrega, fechaInicioPe, fechaFinPe) {

        var objResult = { status: true, message: '' }
        var m_vFechaFinEntrega = moment(vFechaFinEntrega, ['DD/MM/YYYY']);
        var m_fechaInicioEntrega = moment(fechaInicioEntrega, ['DD/MM/YYYY']);
        var m_fechaInicioPe = moment(fechaInicioPe, ['DD/MM/YYYY']);
        var m_fechaFinPe = moment(fechaFinPe, ['DD/MM/YYYY']);

        if (m_vFechaFinEntrega.isValid()) {
          if (fechaInicioEntrega != null) {
            if (m_vFechaFinEntrega < m_fechaInicioEntrega) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser inferior a la fecha Inicio (${fechaInicioEntrega}) de Lugar de Sorteo`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe != null) {
            if ((m_vFechaFinEntrega > m_fechaFinPe) || (m_vFechaFinEntrega < m_fechaInicioPe)) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe estar fuera de rango de fecha de la Promoción (desde: ${fechaInicioPe} hasta: ${fechaFinPe}).`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe == null) {
            if (m_vFechaFinEntrega > m_fechaFinPe) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser Superior a la fecha (${fechaFinPe}) Fin de la Promoción`
              }
            }
          }
          if (fechaInicioPe == null && fechaFinPe != null) {
            if (m_vFechaFinEntrega < m_fechaInicioPe) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser inferior a la fecha (${fechaInicioPe}) Inico de la Promoción`
              }
            }
          }

        } else {
          objResult = {
            status: false, message: `Formato Incorrecto, el formato de fecha debe ser DD/MM/YYYY`
          }
        }
        return objResult;
      },
      esFechaFinSorteoCorrecto(vFechaFinSorteo, fechaInicioSorteo, fechaInicioPe, fechaFinPe) {

        var objResult = { status: true, message: '' }

        var m_vFechaFinSorteo = moment(vFechaFinSorteo, ['DD/MM/YYYY']);
        var m_fechaInicioSorteo = moment(fechaInicioSorteo, ['DD/MM/YYYY']);
        var m_fechaInicioPe = moment(fechaInicioPe, ['DD/MM/YYYY']);
        var m_fechaFinPe = moment(fechaFinPe, ['DD/MM/YYYY']);

        if (m_vFechaFinSorteo.isValid()) {
          if (fechaInicioSorteo != null) {
            if (m_vFechaFinSorteo < m_fechaInicioSorteo) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser inferior a la fecha Inicio (${fechaInicioSorteo}) de Lugar de Sorteo`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe != null) {
            if ((m_vFechaFinSorteo > m_fechaFinPe) || (m_vFechaFinSorteo < m_fechaInicioPe)) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe estar fuera de rango de fecha de la Promoción (desde: ${fechaInicioPe} hasta: ${fechaFinPe}).`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe == null) {
            if (m_vFechaFinSorteo > m_fechaFinPe) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser Superior a la fecha (${fechaFinPe}) Fin de la Promoción`
              }
            }
          }
          if (fechaInicioPe == null && fechaFinPe != null) {
            if (m_vFechaFinSorteo < m_fechaInicioPe) {
              objResult = {
                status: false, message: `Fecha Fin Sorteo no debe ser inferior a la fecha (${fechaInicioPe}) Inico de la Promoción`
              }
            }
          }

        } else {
          objResult = {
            status: false, message: `Formato Incorrecto, el formato de fecha debe ser DD/MM/YYYY`
          }
        }
        return objResult;
      },
      esFechaInicioSorteoCorrecto(vFechaInicioSorteo, fechaFinSorteo, fechaInicioPe, fechaFinPe) {
        var objResult = { status: true, message: '' }
        var m_vFechaInicioSorteo = moment(vFechaInicioSorteo, ['DD/MM/YYYY']);
        var m_fechaFinSorteo = moment(fechaFinSorteo, ['DD/MM/YYYY']);
        var m_fechaInicioPe = moment(fechaInicioPe, ['DD/MM/YYYY']);
        var m_fechaFinPe = moment(fechaFinPe, ['DD/MM/YYYY']);

        if (m_vFechaInicioSorteo.isValid()) {
          if (fechaFinSorteo != null) {
            if (m_vFechaInicioSorteo > m_fechaFinSorteo) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser superior a la fecha Fin (${fechaFinSorteo}) de Lugar de Sorteo`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe != null) {
            if ((m_vFechaInicioSorteo > m_fechaFinPe) || (m_vFechaInicioSorteo < m_fechaInicioPe)) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe estar fuera de rango de fecha de la Promoción (desde: ${fechaInicioPe} hasta: ${fechaFinPe}).`
              }
            }
          }
          if (fechaInicioPe != null && fechaFinPe == null) {
            if (m_vFechaInicioSorteo > m_fechaFinPe) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser Superior a la fecha (${fechaFinPe}) Fin de la Promoción`
              }
            }
          }
          if (fechaInicioPe == null && fechaFinPe != null) {
            if (m_vFechaInicioSorteo < m_fechaInicioPe) {
              objResult = {
                status: false, message: `Fecha Inicio Sorteo no debe ser inferior a la fecha (${fechaInicioPe}) Inico de la Promoción`
              }
            }
          }

        } else {
          objResult = {
            status: false, message: `Formato Incorrecto, el formato de fecha debe ser DD/MM/YYYY`
          }
        }
        return objResult;
      },
      /* mensajeVerificacionHora(pOficinaID) {

          let cadena = '';

          axios.get(`${process.env.VUE_APP_API_AJAYU}consultas/fecha_servidor`).then(responseHoraActual => {

              axios.get(`${process.env.VUE_APP_API_AJAYU}dominio/horarioAtencion/${pOficinaID}`).then(responseHoraAtencion => {

                  let horaActualServidor = moment(moment(responseHoraActual.data).add(1, "seconds")).format('HH:mm')

                  let horaAtencion  = '';
                  Object.keys(responseHoraAtencion.data).forEach(propiedad => {
                      const objeto = responseHoraAtencion.data[propiedad]
                      horaAtencion = horaAtencion + objeto.turno.toLowerCase() + ' ['+ objeto.horaInicio.substring(0,5) + ' a '+ objeto.horaFin.substring(0,5) +']. '
                      });

                  let horaFinAtencionAJ = '';
                  if (responseHoraAtencion.data.filter(r => r.turno === 'CONTINUO').length > 0) {
                      horaFinAtencionAJ = responseHoraAtencion.data.filter(r => r.turno === 'CONTINUO')[0].horaFin;
                  } else {
                      horaFinAtencionAJ = responseHoraAtencion.data.filter(r => r.turno === 'TARDE')[0].horaFin;
                  }
                  //cadena = `<br><div style='font-size: 11px; color: red; '><strong>ADVERTENCIA:</strong> Su solicitud se está enviado fuera del horario administrativo de la AJ. Por lo tanto, su trámite será recibido y procesado en el siguiente horario administrativo disponible.<br><br>  <strong>horario adminsitrativo:</strong>  ` + horaAtencion + ` </div>`
                  if (this.hora1MayorAHora2(horaActualServidor, horaFinAtencionAJ)) {
                      cadena = `<br><div style='font-size: 11px; color: red; '><strong>ADVERTENCIA:</strong> Su solicitud se está enviado fuera del horario administrativo de la AJ. Por lo tanto, su trámite será recibido y procesado en el siguiente horario administrativo disponible.<br><br>  <strong>horario adminsitrativo:</strong>  ` + horaAtencion + ` </div>`
                  }
                  return cadena;
              })
                  .catch(error => {
                      return 'Error al obtener fechas'
                  })
          })
              .catch(error => {
                  return 'Error al obtener fechas'

              })
      },*/
      // hora1MayorAHora2(horaActualServidor, horaFinAtencionAJ) {

      //   const [hora1Horas, hora1Minutos] = horaActualServidor.split(':').map(Number);
      //   const [hora2Horas, hora2Minutos] = horaFinAtencionAJ.split(':').map(Number);
      //   const minutosTotalesHora1 = hora1Horas * 60 + hora1Minutos;
      //   const minutosTotalesHora2 = hora2Horas * 60 + hora2Minutos;
      //   return minutosTotalesHora1 > minutosTotalesHora2;
      // },
      hora1MayorAHora2,
      obtieneFonoSegunOfician(pIdOficina) {
        let fono = ''
        switch (pIdOficina) {
          case 1001: fono = process.env.VUE_APP_NUMBER_WHATSAPP_DRLP;
          case 1002: fono = process.env.VUE_APP_NUMBER_WHATSAPP_DRSC;
          case 1003: fono = process.env.VUE_APP_NUMBER_WHATSAPP_DRCB;
        }
        return { fonoOrigen: fono, fonoVista: fono.substring(0, 3) + '- ' + fono.substring(3, fono.length) }
      },
      /*omitirDeptos(lstDeptoAmostrar,lstDeptoAomitir){
          var lstDepto=[];
          lstDeptoAmostrar.forEach(function(item) {
              if(lstDeptoAomitir.filter(x => x.dominio_id==item.dominio_id).length<=0)
                  lstDepto.push(item)
          });
          return lstDepto;
      }*/
    }
    Vue.prototype.$validacion = validacion;
  }
}
